<template>
  <app-center>
    <template v-slot:page>
      <h1>
        {{ message }}
      </h1>
    </template>
  </app-center>
</template>

<script>
import TaskApi from '@/api/TaskApi';
import AppCenter from '@/views/widget/AppCenter.vue';

const taskApi = new TaskApi();
export default {
  name: 'NotificationTaskAction',
  components: { AppCenter },
  data() {
    return {
      actionTaken: false,
      message: '',
    };
  },
  created() {
    const taskActionId = this.$route.params.actionId;
    taskApi.completeTaskWithTaskActionId(taskActionId)
      .then((response) => {
        this.message = response.data.message;
      })
      .catch((err) => {
        this.message = err.response.data.message;
      });
  },
};
</script>
